/**
 * Event Bus for cross-component communication
 *
 * @package Felix
 */

class FelixEventBus {
	constructor() {
		this.events = {}
	}

	/**
	 * Subscribe to an event
	 *
	 * @param {string}   event    Event name
	 * @param {Function} callback Callback function
	 */
	on(event, callback) {
		this.events[event] ??= []
		this.events[event].push(callback)
	}

	/**
	 * Emit an event
	 *
	 * @param {string} event Event name
	 * @param {*}      data  Data to pass to callbacks
	 */
	emit(event, data) {
		this.events[event]?.forEach((callback) => callback(data))
	}

	/**
	 * Unsubscribe from an event
	 *
	 * @param {string}   event    Event name
	 * @param {Function} callback Callback function to remove
	 */
	off(event, callback) {
		if (this.events[event]) {
			this.events[event] = this.events[event].filter((cb) => cb !== callback)
		}
	}
}

export default new FelixEventBus()
